import { createContext } from 'react';

import { ActiveLocale } from '@dnc/baseline';

export const LocaleContext = createContext('es' as ActiveLocale);
